import { usePlatformAnnouncements } from '@/hooks/usePlatformAnnouncements'
import { Stack } from '@mui/material'
import { PlatformAnnouncementBanner } from './PlatformAnnouncementBanner'

const PlatformAnnouncementBar = () => {
  const { announcements, dismiss } = usePlatformAnnouncements()

  if (announcements.length === 0) return null

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {announcements.map((a) => (
        <PlatformAnnouncementBanner key={a.id} announcement={a} onDismiss={dismiss} />
      ))}
    </Stack>
  )
}

export { PlatformAnnouncementBar }
